/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSharePageRequest
 */
export interface ControlSharePageRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlSharePageRequest
     */
    emails: Array<string>;
}

/**
 * Check if a given object implements the ControlSharePageRequest interface.
 */
export function instanceOfControlSharePageRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "emails" in value;

    return isInstance;
}

export function ControlSharePageRequestFromJSON(json: any): ControlSharePageRequest {
    return ControlSharePageRequestFromJSONTyped(json, false);
}

export function ControlSharePageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSharePageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function ControlSharePageRequestToJSON(value?: ControlSharePageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails,
    };
}

